import type { LaneFilterMode } from './heroFilter';

interface LaneOption {
  value: string;
  label: string;
}

interface RecommenderAdvancedFiltersProps {
  filterMode: LaneFilterMode;
  selectedLanes: string[];
  laneOptions: LaneOption[];
  onModeChange: (mode: 'smart' | 'manual') => void;
  onLaneToggle: (lane: string) => void;
}

export function RecommenderAdvancedFilters({
  filterMode,
  selectedLanes,
  laneOptions,
  onModeChange,
  onLaneToggle,
}: RecommenderAdvancedFiltersProps) {
  const isSmart = filterMode === 'smart';

  return (
    <details className="recommender-advanced">
      <summary className="recommender-advanced-summary">
        高度な設定（レーンで候補を絞る）
      </summary>
      <div className="recommender-advanced-body">
        <div className="filter-mode-toggle">
          <button
            type="button"
            className={`filter-mode-btn ${isSmart ? 'active' : ''}`}
            onClick={() => onModeChange('smart')}
          >
            スマート
          </button>
          <button
            type="button"
            className={`filter-mode-btn ${!isSmart ? 'active' : ''}`}
            onClick={() => onModeChange('manual')}
          >
            レーン指定
          </button>
        </div>

        {!isSmart && (
          <div className="lane-selector">
            {laneOptions.map(option => (
              <label key={option.value} className="lane-checkbox">
                <input
                  type="checkbox"
                  checked={selectedLanes.includes(option.value)}
                  onChange={() => onLaneToggle(option.value)}
                />
                <span className="lane-label">{option.label}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </details>
  );
}
